export default function CustomCss(customCss) {
  var style = document.createElement("style");
  style.appendChild(document.createTextNode(customCss["custom-css"]));
  document.getElementsByTagName("head")[0].appendChild(style);
}
